var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"heading-container"},[_c('h3',{staticClass:"ml-2"},[_vm._v(" "+_vm._s(_vm._f("startcase")(_vm.$t("recording_merge_request")))+" ")])]),_c('recording-merge-request-detail',{attrs:{"merge-request-id":_vm.uuid,"always-show-parent-data":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }